export var FileCategory;
(function (FileCategory) {
    FileCategory["USER_AVATAR"] = "user_avatar";
    FileCategory["USER_BANNER"] = "user_banner";
    FileCategory["WORKSPACE_IMAGE"] = "workspace_image";
    FileCategory["ADMIN_BANNER"] = "admin_banner";
    FileCategory["LOGIN_SLIDE"] = "login_slide";
    FileCategory["DOCUMENT"] = "document";
    FileCategory["CHAT_ATTACHMENT"] = "chat_attachment";
    FileCategory["FINANCEIRO_PREVISAO_MEMORIA"] = "financeiro_previsao_memoria";
})(FileCategory || (FileCategory = {}));
